<template>
	<Loader v-if="loading" />
	<div v-else class="">

		<div v-for="file in files" class="margin-bottom">
			<div class="flex small-margin-bottom">
				<div>
					<h2 style="margin: 0px;">{{ file.type }} - {{ file.basename }}</h2>
					<span class="note">Path on server: {{ file.path }}</span>
				</div>
				<div class="flex-grow text-right">
					<button :disabled="saving" v-on:click="save(file)">Save</button>
				</div>
			</div>
			<textarea style="width: 100%;" rows="14" v-model="file.source"></textarea>
		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: [
    'id'
  ],
  data: () => ({
    loading: false,
    saving: false,
    files: {}
  }),
  computed: {
    ...mapGetters([])
  },
  methods: {
    save (file) {
      Vue.$api.patch('/order/' + this.id + '/file', {
        source: file.source,
        path: file.path
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    load () {
      Vue.$api.get('/order/' + this.id + '/files', {}, {
        loader: toggle => this.loading = toggle,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.files = data
    }
  },
  created () {
    this.load()
  }
}
</script>
